export default __webpack_public_path__ + "static/media/clock_feature.dc8e4dc2.svg";